import React from 'react';
import { Paper, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Chart from './Result/Chart';
import Search from './Result/Search';
import '../css/Result.scss';
function Result(props) {
    const { values, handleChange, tabChange, setActiveIndex, setChartVisibleStyle, 
        checkboxHandleChange, setShishoKozoKubun } = props;
    const back = () => {
        props.setChartVisibleStyle({display: 'none'});
        props.setShishoKozoKubun("");
        window.scrollTo(0, 0);
    }
    return (
        <div className="layout">
            <Chart values={values} handleChange={handleChange} setActiveIndex={setActiveIndex} setShishoKozoKubun={setShishoKozoKubun} setChartVisibleStyle={setChartVisibleStyle} />
            {values.chartParam.shishoKozoKubun === '' && (
                <Search values={values} tabChange={tabChange} checkboxHandleChange={checkboxHandleChange} setChartVisibleStyle={setChartVisibleStyle} />
            )}
            {values.chartParam.shishoKozoKubun !== '' && (
                <Paper elevation={0} className="back-button-area">
                    <Button size="large" color="primary" onClick={back} startIcon={<ArrowBackIcon />}>戻る</Button>
                </Paper>
            )}
        </div>
    )
}

export default Result;